import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetIsB2BModeEnabledActionType, TIsB2BModeEnabled } from './types';

export const setIsB2BModeEnabled: (isB2BModeEnabled: boolean) => TIsB2BModeEnabled = actionGenerator<
  ESetIsB2BModeEnabledActionType.Set,
  boolean
>(ESetIsB2BModeEnabledActionType.Set);
